import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 1080
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(0.5)
  },
  description: {
    color: theme.palette.text.secondary,
    maxWidth: 720,
    lineHeight: 1.6
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2.5)
  },
  controls: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    alignItems: 'center'
  },
  quickActions: {
    display: 'flex',
    gap: theme.spacing(1)
  },
  domainGroups: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(280px, 1fr))',
    columnGap: theme.spacing(4),
    rowGap: theme.spacing(3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  domainGroup: {
    minWidth: 0
  },
  groupHeader: {
    minHeight: 72,
    marginBottom: theme.spacing(1)
  },
  groupTitle: {
    fontWeight: 700
  },
  groupDescription: {
    color: theme.palette.text.secondary,
    fontSize: 13,
    lineHeight: 1.5,
    marginTop: theme.spacing(0.5)
  },
  domains: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  domainRow: {
    minHeight: 72,
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& .MuiFormControlLabel-root': {
      alignItems: 'flex-start',
      marginRight: 0
    },
    '& .MuiCheckbox-root': {
      paddingTop: 2
    }
  },
  domainLabel: {
    fontWeight: 600,
    lineHeight: 1.3
  },
  domainDescription: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    lineHeight: 1.5,
    marginTop: 2
  },
  dependencyText: {
    color: theme.palette.text.secondary,
    fontSize: 11,
    marginLeft: 42,
    marginTop: -4
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1.5),
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(2)
  },
  datasetList: {
    padding: theme.spacing(0, 0, 1.5, 2),
    color: theme.palette.text.secondary
  },
  history: {
    marginTop: theme.spacing(3),
    maxWidth: 920
  },
  historyTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(1)
  },
  historyItem: {
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  historyRow: {
    width: '100%',
    border: 0,
    background: 'transparent',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(1.25, 0),
    textAlign: 'left',
    cursor: 'pointer',
    color: theme.palette.text.primary,
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2
    },
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
      flexDirection: 'column'
    }
  },
  historyStatus: {
    fontWeight: 600
  },
  historyMeta: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    marginTop: theme.spacing(0.5)
  },
  historyActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0
  },
  statusCompleted: {
    backgroundColor: '#10b981',
    color: '#fff'
  },
  statusFailed: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText
  },
  muted: {
    color: theme.palette.text.secondary
  }
}))

export default useStyles
